export function videoLazyLoad() {
  const videos = document.querySelectorAll("[data-video-lazy-load]");

  if (!videos.length) return;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        loadVideo(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: "200px 0px" },
  );

  videos.forEach((video) => observer.observe(video));
}

function loadVideo(video) {
  const sources = video.querySelectorAll("source[data-src]");

  if (!sources.length) return;

  sources.forEach((source) => {
    source.src = source.dataset.src;
  });

  video.load();
  video.play().catch(() => {});
}